<template>
  <div>

    <div id="overlay" v-if="fetchingData">
      <div class="spinner"></div>
    </div>


      <div class="col-md-12" style="margin: 1%;">
        <button class="btn btn-primary" @click="back">
          Back to Statements
        </button>
      </div>
      <div style="margin: 0 auto; width: 75%;">
      <div id="frameDiv" class="col">
        <iframe id="frame" :src="sourceUrl" v-on:load="unspin" width="100%" height="1000px" type="application/pdf"/>
      </div>
      <div class="w-100"></div>
      <div class="col">
        <p>
          Trouble viewing embeded pdf's? <a :href="downloadUrl" target="_blank">Download here</a>.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ViewStatement',
  props: [],
  data() {
    return {
      isValidNum: false,
      fetchingData: true,
      erroMessage: '',
    };
  },
  beforeMount() {

  },
  mounted() {
    // (Alex) If any IE version is returned back, remove the overlay preventing navigation (document still loads)

    if (this.GetIEVersion > 0) {
      document.getElementById('overlay').remove();
    }
  },
  methods: {
    back() {
      this.$router.push({ name: 'SiteInvoices', query: this.$route.query });
    },
    unspin() {
      this.fetchingData = false;
    },

    // (Alex) Used to determine IE version (the actaul version is sort of irrelevent here)
    GetIEVersion() {
      const sAgent = window.navigator.userAgent;
      const Idx = sAgent.indexOf('MSIE');

      // If IE, return version number.
      if (Idx > 0) {
        return parseInt(sAgent.substring(Idx + 5, sAgent.indexOf('.', Idx)));
      }
      // If IE 11 then look for Updated user agent string.
      else if (navigator.userAgent.match(/Trident\/7\./)) {
        return 1;
      }

      return 0; // It is not IE
    },
  },
  computed: {
    sourceUrl() {
      if (this.$attrs.type == 'Invoice') {
        var doc = `${window.location.protocol}//${window.location.hostname}`
            + `${window.location.port ? `:${window.location.port}` : ''}/DesWebPortal/api/site/getInvoice?invoiceNumber=${this.$attrs.id}`;
        return doc;
      } else if (this.$attrs.type == 'COO') {
        var doc = `${window.location.protocol}//${window.location.hostname}`
            + `${window.location.port ? `:${window.location.port}` : ''}/DesWebPortal/api/site/getsitecoopdf?COOId=${this.$attrs.id}`;
        return doc;
      }
    },
    downloadUrl() {
      return `${this.sourceUrl}&download=true`;
    },
  },
};

</script>
